__turbopack_context__.v({
  "container": "TotalAmount-module-scss-module__pdghCG__container",
  "label": "TotalAmount-module-scss-module__pdghCG__label",
  "spin": "TotalAmount-module-scss-module__pdghCG__spin",
  "spinner": "TotalAmount-module-scss-module__pdghCG__spinner",
  "subtitle": "TotalAmount-module-scss-module__pdghCG__subtitle",
  "value": "TotalAmount-module-scss-module__pdghCG__value",
});
